import React from 'react';
import { IntlProvider } from 'react-intl';
import { flatten } from 'flat';
import { VerificationForm } from '@sheerid/jslib';
import '@sheerid/jslib/sheerid.css';
import './App.css';
import { isLayoutLanding } from './lib/utils/browser';
import { SocialSharingLandingPageComponent } from './components/SocialSharing/SocialSharingLandingPageComponent';
import { studentMessagesEN } from './lib/intl/en-US';
import { programId } from './programOptions';

const App = () => {
    return (
        isLayoutLanding() ? (
            <IntlProvider locale={'en'} messages={flatten(studentMessagesEN)}>
                <SocialSharingLandingPageComponent programId={programId} />
            </IntlProvider>
        ) : (
            <div className="sid-verification-form">
                <VerificationForm programId={programId} />
            </div>
        )
    );
}

export default App;
